import React, { useState } from "react"
import {
  ActionsView,
  Header,
  LandingWrapperHeader,
  Logo,
  MenuAccess,
  MenuList,
  MenuListItem,
  MenuListItemButton,
  MenuView,
} from "./header.styles"
import LogoQf from "../../images/logo-qf.svg"

import { QUICKFIN_APP_URL } from "gatsby-env-variables"

export default function LandingHeader() {
  const [viewMenu, setViewMenu] = useState(false)

  function toggleViewMenu() {
    setViewMenu(!viewMenu)
  }

  console.log(QUICKFIN_APP_URL);

  return (
    <Header visible={viewMenu}>
      <LandingWrapperHeader>
        <MenuView>
          <Logo src={LogoQf} />
          <div>
            <button
              onClick={() => toggleViewMenu()}
              className={`hamburger hamburger--squeeze ${
                viewMenu ? "is-active" : ""
              }`}
              type="button"
            >
              <span className="hamburger-box">
                <span className="hamburger-inner" />
              </span>
            </button>
          </div>
        </MenuView>
        <ActionsView>
          <MenuList visible={viewMenu}>
            <MenuListItem>
              <MenuListItemButton href={QUICKFIN_APP_URL + "/acesso/#/criar-conta"}>
                Quero me cadastrar
              </MenuListItemButton>
            </MenuListItem>
          </MenuList>
          <MenuAccess href={QUICKFIN_APP_URL}>
            ENTRAR
          </MenuAccess>
        </ActionsView>
      </LandingWrapperHeader>
    </Header>
  )
}
